import { render, staticRenderFns } from "./index.vue?vue&type=template&id=74264c1f&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=74264c1f&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=74264c1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74264c1f",
  null
  
)

export default component.exports